export async function getFacebookData({ url = '', token = '' }) {
  try {
    const response = await fetch(
      'https://graph.facebook.com/' +
        process.env.REACT_APP_FACEBOOK_API_VERSION +
        '/' +
        url +
        '/?access_token=' +
        token +
        '&fields=name',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if (!!!response.ok) {
      throw response.status;
    }
    return response.json();
  } catch (error) {
    throw error;
  }
}

export const getBusinessAccounts = async ({
  userId,
  accessToken,
}: {
  userId: string;
  accessToken: string;
}) => {
  const response = await getFacebookData({
    url: '/' + userId + '/businesses',
    token: accessToken,
  });
  return response;
};

export const getAdAccounts = async ({
  businessId,
  accessToken,
}: {
  businessId: string;
  accessToken: string;
}) => {
  const ownedAccountResponse = await getFacebookData({
    url: '/' + businessId + '/owned_ad_accounts',
    token: accessToken,
  });

  const clientAccountResponse = await getFacebookData({
    url: '/' + businessId + '/client_ad_accounts',
    token: accessToken,
  });
  const combinedResponse = await Promise.all([
    ownedAccountResponse,
    clientAccountResponse,
  ]).then((results) => {
    const [ownedAccountResponse, clientAccountResponse] = results;

    return {
      data: [...ownedAccountResponse.data, ...clientAccountResponse.data],
    };
  });

  return combinedResponse;
};
